(function ($) {
    const iceServers = [{ urls: "stun:stun.l.google.com:19302" }];

    const estado = {
        pc: null,
        localStream: null,
        remoteStream: null,
        recorders: { mix: null },
        audioCtx: null,
        mixDest: null,
        chunks: { mix: [] },
        chamadaId: null,
        encerrando: false,
        ocupado: false,
        timerId: null,
        timerInicio: null,
        toqueId: null,
        toqueAtivo: false,
        toqueCtx: null,
        toqueOsc: [],
    };

    const csrf = function () {
        return $('meta[name="csrf-token"]').attr("content");
    };

    const rota = function (nome, chamadaId) {
        const rotas = window.whatsappCloudCallingRoutes || {};
        const url = rotas[nome] || "";
        return url.replace("__ID__", chamadaId);
    };

    const postJson = function (url, body) {
        return fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "X-CSRF-TOKEN": csrf(),
                "X-Requested-With": "XMLHttpRequest",
            },
            body: JSON.stringify(body),
        }).then(function (res) {
            return res.json().catch(function () {
                return { error: true, message: "Falha na requisição." };
            }).then(function (data) {
                if (!res.ok || !data || data.error) {
                    throw new Error((data && data.message) || "Falha na requisição.");
                }
                return data;
            });
        });
    };

    const getJson = function (url) {
        return fetch(url, {
            headers: {
                Accept: "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        }).then(function (res) {
            return res.json().catch(function () {
                return { error: true, message: "Falha na requisição." };
            }).then(function (data) {
                if (!res.ok || !data || data.error) {
                    throw new Error((data && data.message) || "Falha na requisição.");
                }
                return data;
            });
        });
    };

    const pararToque = function () {
        estado.toqueAtivo = false;
        if (estado.toqueId) {
            clearInterval(estado.toqueId);
            estado.toqueId = null;
        }
        (estado.toqueOsc || []).forEach(function (osc) {
            try {
                osc.stop();
            } catch (e) {}
        });
        estado.toqueOsc = [];
        if (estado.toqueCtx) {
            estado.toqueCtx.close().catch(function () {});
            estado.toqueCtx = null;
        }
        $(".js-whatsapp-cloud-call-icon").removeClass("whatsapp-cloud-call-modal__icon--ringing");
    };

    const tocarBeep = function () {
        if (!estado.toqueAtivo) {
            return;
        }
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) {
            return;
        }
        if (!estado.toqueCtx || estado.toqueCtx.state === "closed") {
            estado.toqueCtx = new AudioCtx();
        }
        if (estado.toqueCtx.state === "suspended") {
            estado.toqueCtx.resume();
        }
        const ctx = estado.toqueCtx;
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = "sine";
        osc.frequency.setValueAtTime(440, ctx.currentTime);
        osc.frequency.setValueAtTime(480, ctx.currentTime + 0.2);
        gain.gain.setValueAtTime(0.0001, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.9);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start();
        osc.stop(ctx.currentTime + 1);
        estado.toqueOsc.push(osc);
    };

    const iniciarToque = function () {
        pararToque();
        estado.toqueAtivo = true;
        $(".js-whatsapp-cloud-call-icon").addClass("whatsapp-cloud-call-modal__icon--ringing");
        tocarBeep();
        estado.toqueId = setInterval(tocarBeep, 2000);
    };

    const statusModal = function (texto) {
        $("#js-whatsapp-cloud-call-status").text(texto || "");
        if (texto === "Chamada recebida") {
            iniciarToque();
            return;
        }
        pararToque();
    };

    const formatarTempo = function (segundos) {
        const min = Math.floor(segundos / 60);
        const seg = segundos % 60;
        return String(min).padStart(2, "0") + ":" + String(seg).padStart(2, "0");
    };

    const pararContador = function () {
        if (estado.timerId) {
            clearInterval(estado.timerId);
        }
        estado.timerId = null;
        estado.timerInicio = null;
        $("#js-whatsapp-cloud-call-timer").addClass("d-none").text("00:00");
    };

    const iniciarContador = function () {
        if (estado.timerId) {
            return;
        }
        estado.timerInicio = Date.now();
        const $timer = $("#js-whatsapp-cloud-call-timer");
        $timer.removeClass("d-none").text("00:00");
        estado.timerId = setInterval(function () {
            const segundos = Math.floor((Date.now() - estado.timerInicio) / 1000);
            $timer.text(formatarTempo(segundos));
        }, 1000);
        avisoChamadaEmAndamento();
    };

    const mostrarSalvando = function () {
        $("#js-whatsapp-cloud-call-atender, #js-whatsapp-cloud-call-recusar, #js-whatsapp-cloud-call-encerrar").addClass("d-none");
        $("#js-whatsapp-cloud-call-timer").addClass("d-none");
        $("#js-whatsapp-cloud-call-salvando").removeClass("d-none");
        $("#js-whatsapp-cloud-call-salvando-texto").text("Salvando a gravação...");
        statusModal("Chamada encerrada");
    };

    const abrirModal = function (titulo, incoming) {
        $("#js-whatsapp-cloud-call-salvando").addClass("d-none");
        $("#js-whatsapp-cloud-call-title").text(titulo);
        $("#js-whatsapp-cloud-call-atender").toggleClass("d-none", !incoming);
        $("#js-whatsapp-cloud-call-recusar").toggleClass("d-none", !incoming);
        $("#js-whatsapp-cloud-call-encerrar").toggleClass("d-none", incoming);
        $("#modalWhatsAppCloudCalling").modal("show");
    };

    const fecharModal = function () {
        $("#modalWhatsAppCloudCalling").modal("hide");
    };

    const chamadaAtivaEmAndamento = function () {
        return Boolean(estado.timerId) && !estado.encerrando;
    };

    const avisoChamadaEmAndamento = function () {
        if (typeof showToastWarning !== "function") {
            return;
        }
        showToastWarning(
            $("body"),
            "Chamada em andamento. Não recarregue nem saia desta página."
        );
    };

    const limpar = function () {
        ["mix"].forEach(function (chave) {
            const rec = estado.recorders[chave];
            if (rec && rec.state !== "inactive") {
                rec.stop();
            }
        });
        if (estado.pc) {
            estado.pc.close();
        }
        if (estado.localStream) {
            estado.localStream.getTracks().forEach(function (t) {
                t.stop();
            });
        }
        if (estado.audioCtx) {
            estado.audioCtx.close().catch(function () {});
        }
        estado.pc = null;
        estado.localStream = null;
        estado.remoteStream = null;
        estado.recorders = { mix: null };
        estado.audioCtx = null;
        estado.mixDest = null;
        estado.chunks = { mix: [] };
        estado.chamadaId = null;
        pararToque();
        estado.encerrando = false;
        estado.ocupado = false;
        pararContador();
        const audio = document.getElementById("js-whatsapp-cloud-remote-audio");
        if (audio) {
            audio.srcObject = null;
        }
    };

    const garantirAudioCtx = function () {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) {
            return null;
        }
        if (!estado.audioCtx || estado.audioCtx.state === "closed") {
            estado.audioCtx = new AudioCtx();
        }
        if (estado.audioCtx.state === "suspended") {
            estado.audioCtx.resume();
        }
        return estado.audioCtx;
    };

    const conectarNoMix = function (stream) {
        if (!estado.audioCtx || !estado.mixDest || !stream || !stream.getAudioTracks().length) {
            return;
        }
        estado.audioCtx.createMediaStreamSource(stream).connect(estado.mixDest);
    };

    const mimeGravacao = function () {
        return MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
            ? "audio/webm;codecs=opus"
            : "audio/webm";
    };

    const criarRecorder = function (chave, stream) {
        if (estado.recorders[chave] || !stream || !stream.getAudioTracks().length) {
            return;
        }
        estado.chunks[chave] = [];
        const rec = new MediaRecorder(stream, { mimeType: mimeGravacao() });
        rec.ondataavailable = function (e) {
            if (e.data && e.data.size) {
                estado.chunks[chave].push(e.data);
            }
        };
        rec.start(1000);
        estado.recorders[chave] = rec;
    };

    const iniciarGravacao = function () {
        if (estado.recorders.mix) {
            return;
        }
        if (
            !estado.localStream ||
            !estado.remoteStream ||
            !estado.remoteStream.getAudioTracks().length
        ) {
            return;
        }
        const ctx = garantirAudioCtx();
        if (!ctx) {
            return;
        }
        estado.mixDest = ctx.createMediaStreamDestination();
        conectarNoMix(estado.localStream);
        conectarNoMix(estado.remoteStream);
        if (!estado.mixDest.stream.getAudioTracks().length) {
            return;
        }
        criarRecorder("mix", estado.mixDest.stream);
    };

    const pararGravacoes = function () {
        const ativos = ["mix"].filter(function (chave) {
            const rec = estado.recorders[chave];
            return rec && rec.state !== "inactive";
        });
        if (!ativos.length) {
            return Promise.resolve();
        }
        return Promise.race([
            Promise.all(
                ativos.map(function (chave) {
                    return new Promise(function (resolve) {
                        estado.recorders[chave].onstop = resolve;
                        estado.recorders[chave].stop();
                    });
                })
            ),
            new Promise(function (resolve) {
                setTimeout(resolve, 2000);
            }),
        ]);
    };

    const blobDaPista = function (chave) {
        const partes = estado.chunks[chave] || [];
        if (!partes.length) {
            return null;
        }
        return new Blob(partes, { type: "audio/webm" });
    };

    const enviarGravacao = function (chamadaId) {
        const mix = blobDaPista("mix");
        if (!mix || !chamadaId) {
            return Promise.resolve();
        }
        const form = new FormData();
        form.append("audio", mix, "chamada.webm");
        return Promise.race([
            fetch(rota("gravacao", chamadaId), {
                method: "POST",
                headers: {
                    "X-CSRF-TOKEN": csrf(),
                    "X-Requested-With": "XMLHttpRequest",
                },
                body: form,
            }),
            new Promise(function (resolve) {
                setTimeout(resolve, 20000);
            }),
        ]);
    };

    const criarPeer = function () {
        const pc = new RTCPeerConnection({ iceServers: iceServers });
        estado.remoteStream = new MediaStream();
        const audio = document.getElementById("js-whatsapp-cloud-remote-audio");
        if (audio) {
            audio.srcObject = estado.remoteStream;
        }
        pc.onconnectionstatechange = function () {
            if (pc.connectionState === "failed" || pc.connectionState === "closed") {
                if (estado.chamadaId && !estado.encerrando) {
                    encerrar(true, true);
                    statusModal("Chamada encerrada");
                    fecharModal();
                }
            }
        };
        pc.ontrack = function (event) {
            const track = event.track;
            if (!track || track.kind !== "audio") {
                return;
            }
            estado.remoteStream.addTrack(track);
            iniciarGravacao();
        };
        estado.pc = pc;
        return pc;
    };

    const obterMicrofone = function () {
        garantirAudioCtx();
        if (estado.localStream) {
            estado.localStream.getTracks().forEach(function (t) {
                t.stop();
            });
        }
        return navigator.mediaDevices.getUserMedia({ audio: true, video: false }).then(
            function (stream) {
                estado.localStream = stream;
                return stream;
            }
        );
    };

    const normalizarSdp = function (sdp) {
        if (!sdp) {
            return sdp;
        }
        const linhas = String(sdp)
            .replace(/\r\n/g, "\n")
            .replace(/\r/g, "\n")
            .split("\n")
            .filter(function (linha) {
                return linha.length > 0;
            });

        return linhas.join("\r\n") + "\r\n";
    };

    const aplicarSdpRemoto = function (pc, tipo, sdp) {
        return pc.setRemoteDescription({
            type: String(tipo || "answer").toLowerCase(),
            sdp: normalizarSdp(sdp),
        });
    };

    const esperarIce = function (pc) {
        if (pc.iceGatheringState === "complete") {
            return Promise.resolve();
        }
        return new Promise(function (resolve) {
            const timer = setTimeout(resolve, 2500);
            pc.onicegatheringstatechange = function () {
                if (pc.iceGatheringState === "complete") {
                    clearTimeout(timer);
                    resolve();
                }
            };
        });
    };

    const pollResposta = function (chamadaId, tentativas) {
        if (!chamadaId) {
            return Promise.reject(new Error("Falha ao iniciar a chamada."));
        }
        if (tentativas <= 0) {
            return Promise.reject(new Error("Cliente não atendeu."));
        }
        return getJson(rota("sessao", chamadaId)).then(function (res) {
            if (res && res.encerrada) {
                return Promise.reject(new Error("Chamada encerrada."));
            }
            if (res && res.aceita && res.sdp && String(res.sdp_type || "").toLowerCase() === "answer") {
                return res;
            }
            return new Promise(function (resolve) {
                setTimeout(resolve, 2000);
            }).then(function () {
                return pollResposta(chamadaId, tentativas - 1);
            });
        });
    };

    const ligar = function (oportunidadeId, telefone) {
        if (estado.ocupado || estado.pc) {
            return;
        }
        estado.ocupado = true;
        abrirModal("Ligando pelo WhatsApp...", false);
        statusModal("Conectando microfone...");
        obterMicrofone()
            .then(function (stream) {
                const pc = criarPeer();
                stream.getTracks().forEach(function (track) {
                    pc.addTrack(track, stream);
                });
                return pc.createOffer().then(function (offer) {
                    return pc.setLocalDescription(offer).then(function () {
                        return esperarIce(pc);
                    });
                });
            })
            .then(function () {
                statusModal("Chamando o cliente...");
                return postJson(rota("iniciar"), {
                    oportunidade_id: oportunidadeId,
                    telefone: telefone,
                    sdp: normalizarSdp(estado.pc.localDescription.sdp),
                });
            })
            .then(function (res) {
                if (!res || res.error || !res.chamada_id) {
                    throw new Error((res && res.message) || "Falha ao iniciar a chamada.");
                }
                estado.chamadaId = res.chamada_id;
                statusModal("Aguardando o cliente atender...");
                return pollResposta(res.chamada_id, 30);
            })
            .then(function (sessao) {
                return aplicarSdpRemoto(estado.pc, "answer", sessao.sdp);
            })
            .then(function () {
                estado.ocupado = false;
                statusModal("Em chamada");
                iniciarContador();
                $("#js-whatsapp-cloud-call-encerrar").removeClass("d-none");
                if (!estado.recorders.mix) {
                    iniciarGravacao();
                }
                vigiarEncerramento(estado.chamadaId);
            })
            .catch(function (err) {
                statusModal(err.message || "Não foi possível ligar.");
                encerrar(true);
                if ((err.message || "").indexOf("encerrada") >= 0) {
                    fecharModal();
                }
            });
    };

    const atender = function () {
        if (!estado.chamadaId || estado.ocupado) {
            return;
        }
        estado.ocupado = true;
        statusModal("Atendendo...");
        getJson(rota("sessao", estado.chamadaId))
            .then(function (sessao) {
                if (!sessao || sessao.error || !sessao.sdp) {
                    throw new Error((sessao && sessao.message) || "Sessão expirada.");
                }
                return obterMicrofone().then(function (stream) {
                    const pc = criarPeer();
                    stream.getTracks().forEach(function (track) {
                        pc.addTrack(track, stream);
                    });
                    return pc
                        .setRemoteDescription({
                            type: String(sessao.sdp_type || "offer").toLowerCase(),
                            sdp: normalizarSdp(sessao.sdp),
                        })
                        .then(function () {
                            return pc.createAnswer();
                        })
                        .then(function (answer) {
                            return pc.setLocalDescription(answer);
                        })
                        .then(function () {
                            return esperarIce(pc);
                        });
                });
            })
            .then(function () {
                return postJson(rota("atender", estado.chamadaId), {
                    sdp: normalizarSdp(estado.pc.localDescription.sdp),
                });
            })
            .then(function (res) {
                if (!res || res.error) {
                    throw new Error((res && res.message) || "Falha ao atender.");
                }
                estado.ocupado = false;
                statusModal("Em chamada");
                iniciarContador();
                $("#js-whatsapp-cloud-call-atender").addClass("d-none");
                $("#js-whatsapp-cloud-call-recusar").addClass("d-none");
                $("#js-whatsapp-cloud-call-encerrar").removeClass("d-none");
                if (!estado.recorders.mix) {
                    iniciarGravacao();
                }
            })
            .catch(function (err) {
                estado.ocupado = false;
                if (estado.pc) {
                    estado.pc.close();
                    estado.pc = null;
                }
                statusModal(err.message || "Não foi possível atender.");
            });
    };

    const recusar = function () {
        if (!estado.chamadaId) {
            fecharModal();
            return;
        }
        postJson(rota("recusar", estado.chamadaId), {}).finally(function () {
            limpar();
            fecharModal();
        });
    };

    const encerrar = function (silencioso, jaEncerrada) {
        const chamadaId = estado.chamadaId;
        if (estado.encerrando) {
            return;
        }
        estado.encerrando = true;
        if (chamadaId && !jaEncerrada) {
            postJson(rota("encerrar", chamadaId), {}).catch(function () {});
        }
        if (estado.pc) {
            estado.pc.close();
            estado.pc = null;
        }
        pararToque();
        pararContador();
        mostrarSalvando();
        pararGravacoes()
            .then(function () {
                if (estado.localStream) {
                    estado.localStream.getTracks().forEach(function (t) {
                        t.stop();
                    });
                    estado.localStream = null;
                }
                return enviarGravacao(chamadaId);
            })
            .finally(function () {
                limpar();
                fecharModal();
            });
    };

    const vigiarEncerramento = function (chamadaId, tentativas) {
        if (!chamadaId || estado.encerrando) {
            return;
        }
        if (tentativas === undefined) {
            tentativas = 180;
        }
        if (tentativas <= 0) {
            return;
        }
        getJson(rota("sessao", chamadaId)).then(function (res) {
            if (res && res.encerrada) {
                encerrar(true, true);
                return;
            }
            setTimeout(function () {
                vigiarEncerramento(chamadaId, tentativas - 1);
            }, 2000);
        }).catch(function () {
            setTimeout(function () {
                vigiarEncerramento(chamadaId, tentativas - 1);
            }, 2000);
        });
    };

    const handleNotificacao = function (body) {
        if (!body) {
            return;
        }
        if (window.whatsappCloudCallingAtivoLoja !== true) {
            return;
        }
        if ($("#modalOportunidadeFullscreen").hasClass("show")) {
            return;
        }
        const mesmaChamada = estado.chamadaId && Number(estado.chamadaId) === Number(body.chamada_id);
        if (body.evento === "incoming") {
            if (String(body.user_id ?? "") !== String(window.userId ?? "")) {
                return;
            }
            if (estado.pc || estado.ocupado) {
                return;
            }
            if (
                estado.chamadaId &&
                Number(estado.chamadaId) === Number(body.chamada_id) &&
                $("#modalWhatsAppCloudCalling").hasClass("show")
            ) {
                return;
            }
            estado.chamadaId = body.chamada_id;
            abrirModal("Chamada WhatsApp de " + (body.cliente_nome || "cliente"), true);
            statusModal("Chamada recebida");
            if (typeof showBrowserNotification === "function") {
                showBrowserNotification("Chamada WhatsApp", body.cliente_nome || "Cliente", null);
            }
            return;
        }
        if (body.evento === "answered") {
            if (String(body.user_id ?? "") !== String(window.userId ?? "")) {
                return;
            }
            if (!mesmaChamada) {
                return;
            }
            if (estado.pc || estado.ocupado) {
                statusModal("Em chamada");
                iniciarContador();
                return;
            }
            pararToque();
            estado.chamadaId = null;
            fecharModal();
            return;
        }
        if (body.evento === "ended" && mesmaChamada) {
            encerrar(true, true);
        }
    };

    const sincronizarChamadaEntradaPendente = function () {
        if (estado.pc || estado.ocupado || estado.encerrando) {
            return;
        }
        if ($("#modalOportunidadeFullscreen").hasClass("show")) {
            return;
        }
        const url = rota("pendente");
        if (!url) {
            return;
        }
        getJson(url).then(function (res) {
            if (!res || res.error || !res.chamada) {
                return;
            }
            handleNotificacao({
                tipo: "whatsappCloudChamada",
                evento: "incoming",
                user_id: res.chamada.user_id,
                chamada_id: res.chamada.chamada_id,
                cliente_nome: res.chamada.cliente_nome,
                oportunidade_id: res.chamada.oportunidade_id,
            });
        }).catch(function () {});
    };

    window.WhatsAppCloudCalling = {
        handleNotificacao: handleNotificacao,
        sincronizarChamadaEntradaPendente: sincronizarChamadaEntradaPendente,
    };

    const classesBotaoLigacao = "js-whatsapp-cloud-ligar js-whatsapp-cloud-pedir-permissao js-whatsapp-cloud-template-ligacao";

    const aplicarPermissaoBotao = function ($btn, dados) {
        if (dados && dados.pode_ligar) {
            $btn
                .removeClass(classesBotaoLigacao)
                .addClass("js-whatsapp-cloud-ligar")
                .attr("title", "Ligar pelo WhatsApp")
                .html('<i class="fab fa-whatsapp"></i> Ligar');
            return;
        }

        if (String($btn.attr("data-janela")) !== "1") {
            $btn
                .removeClass(classesBotaoLigacao)
                .addClass("js-whatsapp-cloud-template-ligacao")
                .attr("title", "A janela de 24h está fechada. Envia o template de permissão de ligação.")
                .html('<i class="fab fa-whatsapp"></i> Enviar template de ligação');
            return;
        }

        const aviso = (dados && (dados.aviso || dados.message)) || "Pedir autorização permanente no WhatsApp";
        $btn
            .removeClass(classesBotaoLigacao)
            .addClass("js-whatsapp-cloud-pedir-permissao")
            .attr("title", aviso)
            .html('<i class="fab fa-whatsapp"></i> Pedir permissão de ligação');
    };

    const atualizarPermissaoBotao = function ($btn) {
        const oportunidadeId = $btn.attr("data-oportunidade-id");
        const telefone = $btn.attr("data-telefone");
        if (!oportunidadeId || !telefone) {
            return;
        }
        const base = rota("permissao");
        if (!base) {
            return;
        }
        const url = base + (base.indexOf("?") >= 0 ? "&" : "?")
            + "oportunidade_id=" + encodeURIComponent(oportunidadeId)
            + "&telefone=" + encodeURIComponent(telefone);
        getJson(url).then(function (dados) {
            aplicarPermissaoBotao($btn, dados);
        }).catch(function (err) {
            aplicarPermissaoBotao($btn, { pode_ligar: false, aviso: err.message });
        });
    };

    const pedirPermissao = function (oportunidadeId, telefone, $btn) {
        postJson(rota("pedirPermissao"), {
            oportunidade_id: oportunidadeId,
            telefone: telefone,
        }).then(function (dados) {
            showToastSuccess($("body"), dados.message || "Pedido enviado no WhatsApp.");
            atualizarPermissaoBotao($btn);
        }).catch(function (err) {
            showToastDanger($("body"), err.message || "Não foi possível pedir autorização.");
        });
    };

    Eloca.behaviors.whatsappCloudCalling = function (context) {
        $(".js-whatsapp-cloud-ligar, .js-whatsapp-cloud-pedir-permissao, .js-whatsapp-cloud-template-ligacao", context).each(function () {
            atualizarPermissaoBotao($(this));
        });
    };

    $(document).on("click", ".js-whatsapp-cloud-ligar", function () {
        ligar($(this).attr("data-oportunidade-id"), $(this).attr("data-telefone"));
    });
    $(document).on("click", ".js-whatsapp-cloud-pedir-permissao", function () {
        pedirPermissao($(this).attr("data-oportunidade-id"), $(this).attr("data-telefone"), $(this));
    });
    $(document).on("click", ".js-whatsapp-cloud-template-ligacao", function () {
        const $btn = $(this);
        const $modal = $("#modalTemplateLigacao");
        const $itens = $modal.find(".js-radio-template-ligacao");
        if (!$itens.length) {
            showToastDanger($("body"), $modal.attr("data-vazio") || "Cadastre um template de ligação no WhatsApp Cloud e aguarde a aprovação da Meta.");
            return;
        }
        $modal.data("oportunidade-id", $btn.attr("data-oportunidade-id"));
        $modal.data("telefone", $btn.attr("data-telefone"));
        $itens.removeClass("active");
        $itens.first().addClass("active").find("input").prop("checked", true);
        $modal.appendTo("body").modal("show");
    });

    $(document).on("click", "#modalTemplateLigacao .js-radio-template-ligacao", function () {
        const $modal = $("#modalTemplateLigacao");
        $modal.find(".js-radio-template-ligacao").removeClass("active");
        $(this).addClass("active").find("input").prop("checked", true);
    });

    $(document).on("click", ".js-enviar-template-ligacao", function () {
        const $btn = $(this);
        const $modal = $("#modalTemplateLigacao");
        const templateId = $modal.find("input[name=template_ligacao_id]:checked").val();
        if (!templateId) {
            showToastDanger($("body"), "Escolha um template de ligação.");
            return;
        }
        if ($btn.prop("disabled")) {
            return;
        }
        $btn.prop("disabled", true);
        postJson(rota("enviarTemplate"), {
            oportunidade_id: $modal.data("oportunidade-id"),
            telefone: $modal.data("telefone"),
            template_id: templateId,
        }).then(function (dados) {
            $modal.modal("hide");
            showToastSuccess($("body"), dados.message || "Template de ligação enviado no WhatsApp.");
        }).catch(function (err) {
            showToastDanger($("body"), err.message || "Não foi possível enviar o template de ligação.");
        }).finally(function () {
            $btn.prop("disabled", false);
        });
    });

    const escaparHtml = function (texto) {
        return String(texto || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    };

    const renderizarTranscricao = function ($conteudo, texto) {
        let mensagens = null;
        try {
            const parsed = JSON.parse(texto);
            if (Array.isArray(parsed)) {
                mensagens = parsed;
            }
        } catch (e) {
            mensagens = null;
        }
        if (!mensagens) {
            $conteudo.text(texto);
            return;
        }
        let html = "";
        mensagens.forEach(function (mensagem) {
            if (!mensagem || !mensagem.texto) {
                return;
            }
            const lado = String(mensagem.speaker) === "0" ? "esquerda" : "direita";
            html +=
                '<div class="bemmelhor-v2-chat__msg bemmelhor-v2-chat__msg--' +
                lado +
                '"><div class="bemmelhor-v2-chat__autor">' +
                escaparHtml(mensagem.speaker_name || "Participante") +
                '</div><div class="bemmelhor-v2-chat__balao">' +
                escaparHtml(mensagem.texto) +
                "</div></div>";
        });
        $conteudo.html(html);
    };

    const abrirTextoModal = function (tipo, texto) {
        if (tipo === "transcricao") {
            const $modal = $("#modalBemMelhorV2Transcricao");
            const $conteudo = $modal.find(".js-bemmelhor-v2-transcricao-texto");
            const $vazio = $modal.find(".js-bemmelhor-v2-transcricao-vazia");
            $conteudo.empty();
            $vazio.addClass("d-none").text("");
            if (texto) {
                renderizarTranscricao($conteudo, texto);
            } else {
                $vazio.text("Transcrição indisponível.").removeClass("d-none");
            }
            $modal.modal("show");
            return;
        }

        if (tipo === "resumo") {
            const $modal = $("#modalBemMelhorV2Resumo");
            const $conteudo = $modal.find(".js-bemmelhor-v2-resumo-texto");
            const $vazio = $modal.find(".js-bemmelhor-v2-resumo-vazia");
            $conteudo.text(texto || "");
            $vazio.addClass("d-none").text("");
            if (!texto) {
                $vazio.text("Resumo indisponível.").removeClass("d-none");
            }
            $modal.modal("show");
        }
    };

    $(document).on("click", ".js-chamada-texto-modal", function (event) {
        event.preventDefault();
        abrirTextoModal($(this).attr("data-tipo"), $(this).attr("data-texto") || "");
    });

    $(document).on("click", ".js-whatsapp-cloud-gravacao", function (event) {
        event.preventDefault();
        const url = $(this).attr("data-audio-url") || "";
        if (!/^https?:\/\//i.test(url)) {
            return;
        }
        const $modal = $("#modalBemMelhorV2Gravacao");
        const audio = $modal.find(".js-bemmelhor-v2-audio").get(0);
        const $vazio = $modal.find(".js-bemmelhor-v2-gravacao-vazia");
        if (!audio) {
            return;
        }
        audio.pause();
        audio.src = url;
        audio.load();
        $vazio.addClass("d-none");
        $modal.modal("show");
    });

    $(document).one("click keydown", function () {
        garantirAudioCtx();
    });

    if (window.whatsappCloudCallingAtivoLoja === true) {
        const intervaloPollChamadaPendenteMs = 30000;

        sincronizarChamadaEntradaPendente();
        window.setInterval(function () {
            if (document.hidden) {
                return;
            }
            sincronizarChamadaEntradaPendente();
        }, intervaloPollChamadaPendenteMs);

        document.addEventListener("visibilitychange", function () {
            if (!document.hidden) {
                sincronizarChamadaEntradaPendente();
            }
        });
    }

    window.addEventListener("beforeunload", function (event) {
        if (!chamadaAtivaEmAndamento()) {
            return;
        }
        event.preventDefault();
        event.returnValue = "";
    });

    $(document).on("keydown", function (event) {
        if (!chamadaAtivaEmAndamento()) {
            return;
        }
        const tecla = event.key || "";
        const recarregar =
            tecla === "F5" ||
            (event.ctrlKey && (tecla === "r" || tecla === "R")) ||
            (event.metaKey && (tecla === "r" || tecla === "R"));
        if (!recarregar) {
            return;
        }
        event.preventDefault();
        avisoChamadaEmAndamento();
    });

    $(document).on("click", "#js-whatsapp-cloud-call-atender", atender);
    $(document).on("click", "#js-whatsapp-cloud-call-recusar", recusar);
    $(document).on("click", "#js-whatsapp-cloud-call-encerrar", function () {
        encerrar(false);
    });
})(jQuery);
